/** Normalize core's route slug to the entity id used by table rows and route actions. */
export function normalizeRbacRoute(raw: unknown): unknown {
  if (typeof raw !== 'object' || raw === null) return raw;
  const value = raw as Record<string, unknown>;
  const rawFields =
    value.fields ??
    value.payload_fields ??
    value.payloadProperties ??
    value.body_fields ??
    value.payload;
  const fields = Array.isArray(rawFields)
    ? rawFields.map((field) => {
        if (typeof field !== 'object' || field === null) {
          return { path: '', type: 'unknown' };
        }
        const item = field as Record<string, unknown>;
        return {
          ...item,
          path: item.path ?? item.name ?? item.key,
          type: item.type ?? item.value_type ?? item.data_type ?? 'unknown',
        };
      })
    : rawFields && typeof rawFields === 'object'
      ? Object.entries(rawFields).map(([path, type]) => ({
          path,
          type: typeof type === 'string' ? type : 'unknown',
        }))
      : rawFields;
  const normalized =
    fields !== undefined && value.fields === undefined ? { ...value, fields } : value;
  if (!('slug' in normalized)) return normalized;
  if ('id' in normalized && typeof normalized.id === 'string' && normalized.id !== '')
    return normalized;
  return { ...normalized, id: normalized.slug };
}
